import { api } from "assets/scripts/utilities/api-clients";

const prepareProduct = (product) => {
  const { brand_id, category_id, subcategory_id } = product;

  product = {
    ...product,
    brand_id: brand_id?._id || brand_id,
    category_id: category_id?._id || category_id,
    subcategory_id: subcategory_id?._id || subcategory_id,
  };

  return product;
};

export const count = async (options) => {
  const response = await api.get("/kam/products/count", options);

  return response;
};

export const get = async (id) => {
  const response = await api.get(`/kam/products/${id}`);

  return response;
};

export const index = async (options = {}) => {
  const response = await api.get("/kam/products", options);

  return response;
};

export const post = async (product) => {
  product = prepareProduct(product);

  const response = await api.post("/kam/products", product);

  return response;
};

export const put = async (product) => {
  product = prepareProduct(product);

  if (product.status_cd === "rejected") {
    product.status_cd = "requested";

    product.reason = "";

    product.is_active = false;
  }

  const response = await api.put(`/kam/products/${product._id}`, product);

  return response;
};

export const putStatus = async (_id, is_active) => {
  const payload = {
    is_active,
  };

  const response = await api.put(`/kam/products/status/${_id}`, payload);

  return response;
};

export const putApproveProductApi = async (product) => {
  product = prepareProduct(product);

  const response = api.put(`/kam/products/approve/${product?._id}`, product);

  return response;
};

export const putRejectProductApi = async (product) => {
  product = prepareProduct(product);

  const response = api.put(`/kam/products/reject/${product?._id}`, product);

  return response;
};
